import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useCallback } from "react";
import { AssetsSearchSuggestions } from "~/components/AssetsSearchBar/AssetsSearchSuggestions";
import { SearchBar } from "~/components/SearchBar/SearchBar";
const _AssetsSearchBar = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { boardSuggestions = [], textSuggestions = [], savedFilterSuggestions = [], onSavedFilterClick, onBoardClick, ...props } = param;
    const renderSuggestions = useCallback((param)=>{
        let { applyTextSearch, onClick, value } = param;
        return /*#__PURE__*/ _jsx(AssetsSearchSuggestions, {
            onBoardClick: (board)=>{
                onClick(board.title, "board");
                onBoardClick(board);
            },
            onSavedFilterClick: (savedFilter)=>{
                onClick(savedFilter.name, "savedFilter");
                onSavedFilterClick === null || onSavedFilterClick === void 0 ? void 0 : onSavedFilterClick(savedFilter);
            },
            onTextClick: (text)=>{
                applyTextSearch(text);
            },
            textSuggestions: textSuggestions,
            savedFilterSuggestions: savedFilterSuggestions,
            boardsSectionTitle: value ? "Jump to" : "Recent boards",
            savedFiltersSectionTitle: value ? "Jump to" : "Recent saved filters",
            boardSuggestions: boardSuggestions.slice(0, 5)
        });
    }, [
        boardSuggestions,
        onBoardClick,
        onSavedFilterClick,
        savedFilterSuggestions,
        textSuggestions
    ]);
    const handleSuggestionsEnterClick = useCallback((_text, suggestion)=>{
        const boardId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.dataset["boardId"];
        const savedFilterId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.dataset["savedFilterId"];
        if (!!boardId) {
            const clickedBoard = boardSuggestions.find((param)=>{
                let { id } = param;
                return id === boardId;
            });
            if (clickedBoard) {
                onBoardClick(clickedBoard);
                return true;
            }
        } else if (!!savedFilterId) {
            const clickedSavedFilter = savedFilterSuggestions.find((param)=>{
                let { id } = param;
                return id === savedFilterId;
            });
            if (clickedSavedFilter) {
                onSavedFilterClick === null || onSavedFilterClick === void 0 ? void 0 : onSavedFilterClick(clickedSavedFilter);
                return true;
            }
        }
        return false;
    }, [
        boardSuggestions,
        onBoardClick,
        onSavedFilterClick,
        savedFilterSuggestions
    ]);
    return /*#__PURE__*/ _jsx(SearchBar, {
        ...props,
        ref: forwardedRef,
        hasSuggestions: !!(textSuggestions.length || boardSuggestions.length || savedFilterSuggestions.length),
        handleSuggestionEnterClick: handleSuggestionsEnterClick,
        renderSuggestions: renderSuggestions
    });
});
_AssetsSearchBar.displayName = "AssetsSearchBar";
export const AssetsSearchBar = /*#__PURE__*/ memo(_AssetsSearchBar);
AssetsSearchBar.displayName = "AssetsSearchBar";
